import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Quote from '../../../components/Quote';
import props from '../../../lib/contentLayoutProps/working-at-kingston/layoutProps';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="why-kingston">
    <h1>Testimonials</h1>
    <div className={styles.quote}>
      <Quote>
        <p>
          Working as a teacher at Kingston International Kindergarten has allowed me the opportunity to be a part of a
          community. A community of students, parents, teachers, and management who work together to make sure that all
          students that enter our school leave with a great sense of self achievement and accomplishment. It is a
          community that truly values the student as a whole and each one as an individual.
        </p>
        <p>
          As an international bilingual school, I have had the opportunity to work alongside teachers of different
          nationalities and have enjoyed working alongside my Putonghua co-teacher. This has allowed me, as a teacher,
          to see how cultures can merge together creating a harmonious environment that is conducive to learning. It is
          really great to have the support of a co-teacher, someone whom you can share ideas with when it comes to
          student based inquiries and lesson planning. It also enhances the value of what can be achieved through
          teamwork and collaboration.
        </p>
        <p>
          As the first IBPYP school in Hong Kong, inquiry and student-driven education is at the centre of all our
          planning meetings and the core of our learning. We are committed to nurturing an appreciation for cultures,
          languages, and open-mindedness. We encourage our students to ask questions, to be thinkers from an early age,
          as it is these young thinkers and inquiring minds that will solve many future challenging situations. It is a
          very rewarding experience to watch and be part of the students' development.
        </p>
        <p>
          At Kingston International Kindergarten there are many opportunities available for professional growth and
          development. We hold teacher training both internally and externally. Teachers are often given the opportunity
          to attend training and networking sessions both nationally and internationally. As a school, we strive to
          continually grow our teaching practices to meet the requirements and challenges of an ever-changing world.
        </p>
      </Quote>
      <div className={styles.cite}>
        <div className={styles.person}>Robyn Nicolas</div>
        <div className={styles.class}>Three Year Old Class Teacher</div>
      </div>
    </div>

    <div className={styles.quote}>
      <Quote>
        <p>
          I have been working at Kingston for nearly 8 years and am very proud to be a teacher and Mathematics
          Coordinator. Here at Kingston, collaborative planning and teamwork are the essence in our approach to teaching
          and learning. Due to our cozy school atmosphere, teachers know each other well on both a personal and
          professional level. Colleagues have a great sense of mutual respect for one another as we strive to provide
          the very best learning experiences for our students. I have made lifelong friendships while working here.
        </p>
        <p>
          It is a joy to be involved in the growth and development of my wonderful students. I have seen them grow to
          become mature and capable global citizens, with the necessary skills to tackle real issues they may face
          throughout their teenage and adult lives. Kingston students are wonderfully curious and committed to their
          success and are an absolute joy to work with.
        </p>
        <p>
          At Kingston, we have an abundance of resources. When teachers find a useful resource that can help enhance
          teaching and learning here, it is seriously considered by our approachable administrative team. We establish
          excellent relationships with companies both in Hong Kong and abroad in order to ensure we are purchasing the
          very best resources and equipment. As a school we are progressive with technology and are constantly learning
          new pedagogy to enhance the transdisciplinary nature of our program.
        </p>
        <p>
          Here at Kingston there are many enriching opportunities for professional growth and development. Kingston
          invites Education experts from around the world to visit and facilitate professional development workshops for
          teachers. In addition to our yearly in-school professional development, I have the opportunity to attend
          workshops and conferences in line with my professional growth plan. Furthering my understanding of Mathematics
          education has allowed me to flourish in my teaching and leadership role here at Kingston. I was fortunate to
          even attend a Mathematics conference in the United States in 2017. Teachers who have keen professional
          learning interests are supported and nurtured here at Kingston in order to further their journeys into the
          teaching profession.
        </p>
      </Quote>
      <div className={styles.cite}>
        <div className={styles.person}>Kellie Berry</div>
        <div className={styles.class}>PYP Coordinator & Mathematics Coordinator (Former PYP Class Teacher)</div>
      </div>
    </div>

    <div className={styles.quote}>
      <Quote>
        <p>
          光陰似箭，原來在京斯敦已十八年了。這裏不僅是我工作的地點，還是我和學校共同成長，滿載快樂的地方，這就是我第二個家！
        </p>
        <p>
          最專業、最用心的學校——二零零零年，京斯敦引入國際文憑組織的IB課程，讓一直以傳統教學模式教學的我，邁進全新的一種教學領域。每年的培訓，我從最初的迷惘；繼而加深認識；最後由了解到應用，一步步將這個優秀的課程展現出來。今天，當全球正在熱切推薦IB國際文憑課程時，早在二零零四年京斯敦已成為全香港首間認可的IB學校，作為先鋒的我們為此感到無比榮幸。
        </p>
        <p>
          互相合作的工作氛圍——在京斯敦，就像一個大家庭，同事們同心協力，將最佳的教學與同儕分享。我們是全港老師流失量最低的學校，老師們具備著專業、團結的精神，成為全港最優秀團隊的表表者，不論你是哪一個崗位，都共同為學校獻上最真摯的心，在這裏工作，真是非常幸福！
        </p>
        <p>
          自信、有創意的學生——“老師，您看，我的三眼恐龍可愛嗎？”是的，在京斯敦，我們鼓勵孩子勇於表達自己，在探究式學習環境包圍下，小朋友可以發揮無限的創意，胸襟開闊的接納各種不同的觀點，培養具有自信、創意的世界觀孩子。
        </p>
        <p>
          熱心、負責的家長——在京斯敦，家長是學校最珍貴的夥伴和資源，我們關係密切，家長們在教學中給予孩子全力支持，讓他們在學習的成長路上更加豐盛。感謝家長們的積極配合，共同為學校的發展盡一分力量。
        </p>
        <p>
          最溫暖的大家庭——學校是一個學習的地方，我們不只是培養具國際視野、自信的孩子，還有社會上的角色，我們鼓勵孩子走出教室，關心社會。因此，學校經常與不同的慈善團體合作，無論是捐款還是物資，我們總是一呼百應。在這麼充滿愛的大家庭中工作，是我的幸運，感恩感恩！這也是驅使我不斷努力的動力！
        </p>
      </Quote>
      <div className={styles.cite}>
        <div className={styles.person}>Fion Kong</div>
        <div className={styles.class}>Chinese Class Teacher</div>
      </div>
    </div>

    <div className={styles.quote}>
      <Quote>
        <p>轉眼間，這已是我在京斯敦工作的第五年。於我而言，在學校工作的每一天都是無比享受的，我愛這裏。</p>
        <p>
          最專業、最用心的學校——作為香港第一間專業的IB PYP學校，在每一天的教學實踐中，我都能切實體會到學校在IB
          PYP教學方面的專業性和對學生的良苦用心，學生的學習和其它各方面的進步永遠都是學校考慮的首要因素。學校每年提供各種專業培訓使我能夠始終走在教學領域的前端。每次外出參加IB培訓，我們最大的體會就是京斯敦在各個教學領域都做得十分“模範”和超前，因此我對自己的教學職業充滿信心。
        </p>
        <p>
          互助合作的工作氛圍——在京斯敦，我們有一隻以“互助合作”著稱的教師團隊，大家在一起協作共同制定教學計劃；無私分享各種資源，共同進步；課堂上互相配合，力求達到最佳的教學效果......與如此優秀的團隊一起共事，實在是一件幸福之事。
        </p>
        <p>
          自信、有創意的學生——作為老師，沒有什麼比看到自己的學生優秀而更加開心的事情了。在探究式學習環境下，學生的求知慾和學習熱情被大大激發，京斯敦的孩子知識淵博、重合作並富國際情懷，他們個個充滿創意，自信十足！
        </p>
        <p>
          熱心、負責的家長——作為學校社區成員的重要組成部分，京斯敦的家長在我們的教學中給予全力支持，使我們能夠順利貫徹教學理念，且能在學生的成長之路上更加有效地給予他們指引和協助。感謝我們的家長！
        </p>
        <p>
          最溫暖的大家庭——我常和周圍的朋友說，京斯敦是我在香港的第二個家。是的！我很享受在這裏的每一天。工作和生活的這五年，在這所充滿小社區氣息的學校裏，我感受到了來自同事和家長無限的暖意，十分感恩！這一切都是我不斷前行的動力和精神支持！
        </p>
      </Quote>
      <div className={styles.cite}>
        <div className={styles.person}>Kerry Xu</div>
        <div className={styles.class}>Chinese Coordinator & Year 5 Chinese Teacher</div>
      </div>
    </div>
  </ContentLayout>
);
